// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1nzuZ","unreadBadge":"styles_unreadBadge__3ICeX","modalContent":"styles_modalContent__2AhhQ","modal":"styles_modal__bOXHZ"};